import { List, Map } from 'immutable';

import { types as managementTypes } from './../../ducks/team-management';
import { types as teamsTypes } from './../../ducks/teams';

const initialState = Map({
  loading: true,
  autocompletedTeams: List(),
});

const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case managementTypes.INITIAL_USER_TABLE.SUCCESS:
      return state.set('loading', false);
    case teamsTypes.AUTOCOMPLETE_TEAMS_GET.SUCCESS:
      return state.set('autocompletedTeams', List(payload.results));
    default:
      return state;
  }
};

export default usersReducer;
